var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"text-body-2"},[_vm._v(" "+_vm._s(_vm.$t('home.issueItem.header.endRecruitment'))+" : "+_vm._s(_vm.timer)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }